import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AutenticarComponent } from './security/autenticar/autenticar.component';
import { ErrorComponent } from './shared/error/error.component';

const routes: Routes = [
    { path: '', redirectTo: 'pt/alunos', pathMatch: 'full' },
    { path: ':lang/autenticar', component: AutenticarComponent },
    {
        path: '',
        loadChildren: () => import('./core/core.module').then((c) => c.CoreModule),
    },
    { path: ':lang/erro', component: ErrorComponent }
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
